import { postCheckoutMapSettings } from 'services/settings/ppoints/CheckoutMapSettings';
import { CheckoutMapSettingsItem } from '../model/CheckoutMapSettings';
import { useAppSelector } from 'redux/hooks';

const useCheckoutMapSettings = () => {
    const ecoms = useAppSelector((state) => state.ecoms);

    const saveCheckoutMapSettings = (data: CheckoutMapSettingsItem[]): Promise<CheckoutMapSettingsItem[]> => {
        if (!ecoms?.selected?.id) {
            return Promise.reject(new Error('Ecom not selected'));
        }
        return postCheckoutMapSettings(ecoms.selected.id, data);
    };

    return { saveCheckoutMapSettings };
};

export default useCheckoutMapSettings;
